export default "__VITE_ASSET__BpVPPQmu__"